<div class="grid grid-cols-12 gap-4">
  <div class="col-span-6">
    <microsec-card class="detail-card" [isNestedCard]="true" [isFull]="true">
      <div class="card-icon icon-container">
        <i class="fas fa-biohazard icon"></i>
      </div>
      <div class="flex flex-col gap-4">
        <label class="font-bold">Device Status</label>
        <label
          class="!capitalize text-2xl"
          [ngClass]="{
            'text-green': device.status === 'normal',
            'text-red': device.status !== 'normal'
          }">
          {{ device.status || '-' }}
        </label>
        <div>
          <p-chip
            class="cursor-pointer"
            [label]="'Threat Score: ' + ((device.threat_score | number: '1.0-0') || 0)"
            (click)="goToTab.emit('threat')"></p-chip>
        </div>
      </div>
    </microsec-card>
  </div>
  <div class="col-span-6">
    <microsec-card class="detail-card" [isNestedCard]="true" [isFull]="true">
      <div class="card-icon icon-container">
        <i class="fas fa-sitemap icon"></i>
      </div>
      <div class="flex flex-col gap-4">
        <label class="font-bold">Device Configuration</label>
        <label class="text-2xl"> Criticality: {{ device.criticality || 0 }}/10 </label>
        <div>
          <p-chip
            class="cursor-pointer"
            [label]="'Network Level: ' + ((device.network_map_level | constant: 'detected-device-network-map-level') || '-')"
            (click)="goToNetworkMapPage()"></p-chip>
        </div>
      </div>
    </microsec-card>
  </div>

  <!-- Device Details -->

  <div class="col-span-12">
    <microsec-card class="detail-card" [isNestedCard]="true" [isFull]="true">
      <div class="card-icon icon-container">
        <i class="pi pi-info-circle icon"></i>
      </div>
      <div class="flex flex-col gap-4">
        <label class="font-bold"> Device Details </label>
        <div class="text-center">
          <p-selectButton
            class="device-selectbutton"
            [options]="detailsViewOptions"
            [(ngModel)]="selectedDetailsView"
            optionLabel="label"
            optionValue="value"
            [allowEmpty]="false" />
        </div>

        <div class="list-fields mx-4">
          @if (selectedDetailsView === 'hardware') {
            @if (
              !!device?.macAddress ||
              !!device?.ipAddress ||
              !!device?.unitId ||
              !!device?.type ||
              !!device?.manufacturer ||
              (!!device?.model && device.model.toLowerCase() !== 'unknown' && device.model.toLowerCase() !== 'none') ||
              !!device?.nmap?.os?.osmatch?.[0]?.osclass?.['@vendor']
            ) {
              @if (!!device?.macAddress) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> MAC Address </label>
                  <label class="col-span-8 text-grey"> {{ device.macAddress }} </label>
                </div>
              }
              @if (!!device?.ipAddress) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> IP Address </label>
                  <div class="col-span-8">
                    <div class="text-grey">
                      {{ device.ipAddress.length >= 250 && !viewAllIps ? device.ipAddress.substring(0, 247) + '...' : device.ipAddress }}
                    </div>
                    @if (device.ipAddress.length >= 250) {
                      <div class="ip-toggle link mt-1" (click)="viewAllIps = !viewAllIps">
                        <label class="cursor-pointer">View {{ !!viewAllIps ? 'Less' : 'More' }}</label>
                        <i class="pi pi-chevron-down icon font-bold ml-2" [ngClass]="{ up: !!viewAllIps }"></i>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (!!device?.serial_number) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> Serial Number </label>
                  <label class="col-span-8 text-gray-500">{{ device.serial_number }}</label>
                </div>
              }
              @if (!!device?.bleAddress) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> BLE Address </label>
                  <label class="col-span-8 text-gray-500"> {{ device.bleAddress }} </label>
                </div>
              }
              @if (!!device?.unitId) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> Unit ID </label>
                  <label class="col-span-8 text-gray-500"> {{ device.unitId }} </label>
                </div>
              }
              @if (!!device?.bacnetNumber) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> BACnet MS/TP Address</label>
                  <label class="col-span-8 text-gray-500"> {{ device.bacnetNumber }} </label>
                </div>
              }
              @if (!!device?.dnp3Id) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> DNP3 ID </label>
                  <label class="col-span-8 text-gray-500"> {{ device.dnp3Id }} </label>
                </div>
              }
              @if (!!device?.type) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> Type </label>
                  <label class="col-span-8 text-gray-500"> {{ (device.type | constant: 'detected-device-type') || '-' }} </label>
                </div>
              }
              @if (!!device?.manufacturer) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> Manufacturer </label>
                  <label class="col-span-8 text-gray-500"> {{ device.manufacturer }} </label>
                </div>
              }
              @if (!!device?.model && device.model.toLowerCase() !== 'unknown' && device.model.toLowerCase() !== 'none') {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> Model </label>
                  <label class="col-span-8 text-gray-500"> {{ device.model }} </label>
                </div>
              }
              @if (!!device?.nmap?.os?.osmatch?.[0]?.osclass?.['@vendor']) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> Vendor </label>
                  <label class="col-span-8 text-gray-500"> {{ device.nmap.os.osmatch[0].osclass['@vendor'] }} </label>
                </div>
              }
            } @else {
              <div class="text-center text-grey my-5">No hardware details available</div>
            }
          }
          @if (selectedDetailsView === 'software') {
            @if (
              (!!device?.os && device.os.toLowerCase() !== 'unknown' && device.os.toLowerCase() !== 'none') ||
              !!device.hostname ||
              !!device?.nmap?.os?.osmatch?.[0]?.osclass?.['@osgen'] ||
              !!device?.nmap?.os?.osmatch?.[0]?.['@name'] ||
              !!device?.nmap?.os?.osmatch?.[0]?.osclass?.['cpe'] ||
              !!device?.firmware_version
            ) {
              @if (!!device?.hostname) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> Hostname </label>
                  <label class="col-span-8 text-grey"> {{ device.hostname }} </label>
                </div>
              }
              @if (!!device?.os && device.os.toLowerCase() !== 'unknown' && device.os.toLowerCase() !== 'none') {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> OS </label>
                  <label class="col-span-8 text-grey"> {{ device.os }} </label>
                </div>
              }
              @if (!!device?.nmap?.os?.osmatch?.[0]?.osclass?.['@osgen']) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> OS Version </label>
                  <label class="col-span-8 text-grey"> {{ device.nmap.os.osmatch[0].osclass['@osgen'] }} </label>
                </div>
              }
              @if (!!device?.nmap?.os?.osmatch?.[0]?.['@name']) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> OS Name </label>
                  <label class="col-span-8 text-grey"> {{ device.nmap.os.osmatch[0]['@name'] }} </label>
                </div>
              }
              @if (!!device?.firmware_version) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> Firmware Version </label>
                  <label class="col-span-8 text-grey"> {{ device.firmware_version }} </label>
                </div>
              }
              @if (!!device?.nmap?.os?.osmatch?.[0]?.osclass?.['cpe']) {
                <div class="grid grid-cols-12 gap-4 items-center">
                  <label class="col-span-4 font-bold"> CPE </label>
                  <label class="col-span-8 text-grey"> {{ device.nmap.os.osmatch[0].osclass['cpe'] }} </label>
                </div>
              }
            } @else {
              <div class="text-center text-grey my-8">No software details available</div>
            }
          }
        </div>
      </div>
    </microsec-card>
  </div>

  <!-- TLS Configuration -->

  @if (!!device?.tls && device?.tls.length > 0) {
    <div class="col-span-12">
      <microsec-card class="detail-card" [isNestedCard]="true" [isFull]="true">
        <div class="card-icon icon-container">
          <i class="fas fa-file-shield icon"></i>
        </div>
        <div class="flex flex-col gap-4">
          <label class="font-bold mb-1">TLS Configuration</label>
          <p-accordion [multiple]="false" [value]="0">
            @for (tls of device.tls; track i; let i = $index) {
              <p-accordion-panel styleClass="mb-0" [value]="i">
                <p-accordion-header>
                  {{ tls.tls_version || 'TLS Configuration' + i + 1 }}
                </p-accordion-header>
                <p-accordion-content>
                  <div class="list-fields mx-6">
                    @for (config of TLS_CONFIG_FIELDS; track $index) {
                      @if (!!tls[config.key] || config.type === 'boolean') {
                        <div class="grid grid-cols-12 gap-4 items-center">
                          <label class="col-span-4 font-bold">{{ config.label }}</label>
                          <label class="col-span-8 text-grey">
                            @switch (config.type) {
                              @case ('string') {
                                {{ tls[config.key] || '-' }}
                              }
                              @case ('boolean') {
                                {{ !!tls[config.key] ? 'Yes' : 'No' }}
                              }
                              @case ('number') {
                                {{ tls[config.key] || '-' }}
                              }
                              @case ('datetime') {
                                {{ (tls[config.key] | momentPipe) || '-' }}
                              }
                              @default {
                                -
                              }
                            }
                          </label>
                        </div>
                      }
                    }
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
            }
          </p-accordion>
        </div>
      </microsec-card>
    </div>
  }

  <!-- Other Information -->

  <div class="col-span-12">
    <microsec-card class="detail-card" [isNestedCard]="true" [isFull]="true">
      <div class="card-icon icon-container">
        <i class="fas fa-bars icon"></i>
      </div>
      <div class="flex flex-col gap-4">
        <label class="font-bold">Other Information</label>
        <div class="list-fields mx-4">
          @if (!!device?.application_protocols?.length) {
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4 font-bold"> Application Protocols </label>
              <label class="col-span-8 text-grey">
                {{ device.application_protocols | constant: 'detected-device-application-protocols' : true }}
              </label>
            </div>
          }
          @if (!!device?.vlan_ids?.length) {
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4 font-bold"> VLAN ID </label>
              <label class="col-span-8 text-grey">
                {{ device.vlan_ids | arrayMapPipe: undefined : true }}
              </label>
            </div>
          }
          @if (!!device?.connections?.length) {
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4 font-bold"> Network Connection </label>
              <div class="col-span-8">
                <div class="flex flex-wrap gap-2">
                  @for (connection of device.connections || []; track connection) {
                    <p-chip
                      class="cursor-pointer"
                      label="{{ connection.name || '-' }} ({{ connection.id || '-' }})"
                      (click)="goToConnectionPage(connection.id)"></p-chip>
                  }
                </div>
              </div>
            </div>
          }
          <div class="grid grid-cols-12 gap-4 items-center">
            <label class="col-span-4 font-bold"> Multicast </label>
            <label class="col-span-8 text-grey">
              {{ !!device?.is_multicast ? 'Yes' : 'No' }}
            </label>
          </div>
          @if (!!device?.tags?.length) {
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4 font-bold"> Tags </label>
              <div class="col-span-8">
                <div class="flex flex-wrap gap-2">
                  @for (tag of device.tags; track tag) {
                    <div class="custom-chip" [style]="{ background: util.hexToRgba(tag.color), color: tag.color }">
                      {{ tag.label }}
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (!!device?.zones?.length) {
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4 font-bold"> Zones </label>
              <div class="col-span-8">
                <div class="flex flex-wrap gap-2">
                  @for (zone of device.zones; track zone) {
                    <div class="custom-chip" [style]="{ background: util.hexToRgba(zone.color), color: zone.color }">
                      {{ zone.label }}
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (!!device.compliance?.[COMPLIANCE_STANDARDS.IEC_62443]?.last_assessment_result) {
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4 font-bold"> Criticality </label>
              <label class="col-span-8 text-grey"> {{ device.criticality || 0 }}/10 </label>
            </div>
          }
          @if (!!device.compliance?.[COMPLIANCE_STANDARDS.IEC_62443]?.last_assessment_result) {
            <div class="grid grid-cols-12 gap-4 items-center">
              <label class="col-span-4 font-bold"> Network Map Level </label>
              <label class="col-span-8 text-grey">
                {{ (device.network_map_level | constant: 'detected-device-network-map-level') || '-' }}
              </label>
            </div>
          }
          <div class="grid grid-cols-12 gap-4 items-center">
            <label class="col-span-4 font-bold"> Uses Agent </label>
            <label class="col-span-8 text-grey">
              {{ !!device?.uses_agent ? 'Yes' : 'No' }}
            </label>
          </div>
          <div class="grid grid-cols-12 gap-4 items-center">
            <label class="col-span-4 font-bold"> Imported </label>
            <label class="col-span-8 text-grey">
              {{ !!device?.is_imported ? 'Yes' : 'No' }}
            </label>
          </div>
        </div>
      </div>
    </microsec-card>
  </div>

  <div class="col-span-12">
    <microsec-card class="detail-card" [isNestedCard]="true" [isFull]="true">
      <div class="flex flex-col gap-4">
        <label class="font-bold">Device Timeline</label>
        <microsec-custom-timeline [events]="deviceTimelineEvents"></microsec-custom-timeline>
      </div>
    </microsec-card>
  </div>

  @if (!!device.interfaces?.length) {
    <div class="col-span-12">
      <microsec-card class="detail-card" [isNestedCard]="true" [isFull]="true">
        <div class="flex flex-col gap-4">
          <label class="font-bold">Interfaces</label>
          <microsec-card [isNestedCard]="true" [isTableCard]="true">
            <microsec-common-table
              class="interfaces-main-table"
              [cols]="interfaceMainCols"
              [values]="device.interfaces || []"
              [rows]="PER_PAGE"
              [loading]="isLoading"
              [cellTemplate]="cellTemplate"
              [scrollHeight]="'40rem'"
              dataKey="interface"
              [headerTemplate]="headerTemplate"
              [expansionTemplate]="expansionTemplate"
              [paginator]="false"
              [showContainerHeader]="false">
            </microsec-common-table>
          </microsec-card>
        </div>
      </microsec-card>
    </div>
  }
</div>

<ng-template #headerTemplate></ng-template>

<ng-template #expansionTemplate let-rowData="rowData">
  <tr>
    <td colspan="2" class="no-padding">
      <p-table
        class="interfaces-children-table"
        [value]="rowData.children || []"
        [paginator]="true"
        paginatorDropdownAppendTo="body"
        [rows]="PER_PAGE"
        [rowsPerPageOptions]="PER_PAGE_OPTIONS">
        <ng-template #header>
          <tr>
            <th style="width: 4rem"></th>
            <th style="width: 17rem">Source</th>
            <th style="width: calc(100% - 17rem)">Destination</th>
          </tr>
        </ng-template>
        <ng-template #body let-item>
          <tr>
            <td></td>
            <td>{{ item.source }}</td>
            <td>
              <div class="flex flex-wrap gap-2 my-2">
                @for (dest of item.destination; track dest; let lastDest = $last) {
                  <label
                    >{{ dest }}
                    @if (!lastDest) {
                      <span>,</span>
                    }
                  </label>
                }
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </td>
  </tr>
</ng-template>

<ng-template let-col="col" let-rowData="rowData" #cellTemplate>
  @switch (col.field) {
    @case ('interface') {
      <label class="text-data">
        {{ rowData[col.field] || '' }}
      </label>
    }
    @case ('destination') {
      <div class="flex flex-wrap gap-2 my-2">
        @for (dest of rowData[col.field] || []; track dest; let lastDest = $last) {
          <label>
            {{ dest || '' }}
            @if (!lastDest) {
              <span>,</span>
            }
          </label>
        }
      </div>
    }
    @default {
      <div class="overflow-hidden whitespace-nowrap text-ellipsis">
        {{ rowData[col.field] || '' }}
      </div>
    }
  }
</ng-template>
